import { forwardRef, Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { BenefitsEntity } from './benefits.entity';
import { BenefitXRefEntity } from './benefitsxref.entity';
import { InchargeController } from './incharge.controller';
import { InchargeEntity } from './incharge.entity';
import { InchargeService } from './incharge.service';
import { InchargeXRefEntity } from './inchargexref.entity';
import { MandalListEntity } from './mandal.entity';
import { VillageListEntity } from './village.entity';
import { InchargeBoothXRefEntity } from './boothinchargexref.entity';
import { UserEntity } from '../user/user.entity';


@Module({
  imports: [
    TypeOrmModule.forFeature([VillageListEntity,BenefitsEntity,BenefitXRefEntity,InchargeEntity,InchargeXRefEntity,MandalListEntity
     ,InchargeBoothXRefEntity,UserEntity ])
  ],
  providers: [InchargeService],
  controllers: [InchargeController],
  exports:[InchargeService]
})
export class InchargeModule {}
